import { Injectable } from '@angular/core';

import { WindowRef } from '../common/window-ref';
import { RtPlatform } from '../core/platform/platform';

@Injectable({ providedIn: 'root' })
export class PlatformThemeService {
  public isHighDPI: boolean;

  constructor(
    private platform: RtPlatform,
    public windowRef: WindowRef,
  ) {
    this.isHighDPI = this.gethighDPIDetect();
  }

  public resolveBrowserClassname(): string | void {
    if (!this.platform.WEBKIT) {
      if (this.platform.EDGE || this.platform.TRIDENT || this.platform.OLDER_IE) {
        if (this.platform.EDGE) {
          return 'edge';
        }
        if (this.platform.TRIDENT) {
          return 'ie-11';
        }
        if (this.platform.OLDER_IE) {
          return 'ie-10-below';
        }
      }
    }

    if (this.platform.SAFARI) {
      return 'safari';
    }

    if (this.platform.BLINK || this.platform.WEBKIT) {
      return 'chrome';
    }

    if (this.platform.FIREFOX) {
      return 'firefox';
    }
  }

  private gethighDPIDetect(): boolean {
    const query =
      '(-webkit-min-device-pixel-ratio: 2), (min-device-pixel-ratio: 2), (min-resolution: 192dpi)';
    return 'matchMedia' in this.windowRef.nativeWindow
      ? this.windowRef.nativeWindow.matchMedia(query).matches
      : false;
  }
}
